import  React from 'react';
import $ from 'jquery';

//elegant form validation
import TextView from '../../elegant_form_validation/Util/TextView.js';
import update from 'immutability-helper';
import { run, ruleRunner } from '../../elegant_form_validation/Validation/ruleRunner.js'
import { required } from '../../elegant_form_validation/Validation/rules.js';

import Row from '../ui/Row';
import Col from '../ui/Col';

import RestClient from '../rest/RestClient';
import CommonHelper from '../helpers/CommonHelper';
import Entrance from './Entrance';
import MicroEvent  from '../other/microevent';
import Countdown from "./../helpers/Countdown.js"; 
import Container from 'react-bootstrap/esm/Container.js';

const fieldValidations = [
  ruleRunner("emailAddress", "Email Address", required),
  ruleRunner("password1", "Password", required),
];


export default class LinkAccount extends React.Component {

  state = {
    redirectToReferrer: false,
    loginAttemptStarted:false,
    loginAttemptFailed: false,
    showPassword: false,
    showMoreMessageOnLogin: false,
    showWaitLittleLonger: false,

  }

  pwd="";

  constructor(props) {
    super(props);

    MicroEvent.mixin(LinkAccount);

    this.handleFieldChanged = this.handleFieldChanged.bind(this);
    this.errorFor = this.errorFor.bind(this);
    this.state = {
      showErrors:                         false,
      validationErrors:                   { },
      restError:                          null,
      secondsLeftToNewAccountRedirection: 4,
        ver_mode: "v1"
    }
      fetch('https://staging.soundcloudhelper.com/SCH_Setting.php?IDUser=' + localStorage.IDUser + '&id_account='+Entrance.accountId())
          .then(response => response.json())
          .then(data => {
              // Access the information from the JSON data
              var ver_mode = data.ver_mode;
              this.setState({
                  ver_mode: ver_mode ,
              });

              if(true)
              {
                  // const ver_mode = data.ver_mode;
                  // this.setState({
                  //     ver_mode: ver_mode ,
                  // });

                  var url_string = window.location.href;
                  var url = new URL(url_string);
                  var RA = url.searchParams.get("RA");
                  console.log(RA);

                  if(RA!=null) {
                      ver_mode=RA;
                      this.setState({
                          ver_mode: ver_mode,
                      });
                  }

                  console.log(ver_mode);
              }

          })
          .catch(error => {
              console.error('Error fetching data:', error);
          });
  }
  
  componentWillMount() {
    document.body.classList.add('link-accout-page');

    // Run validations on initial state
    this.setState({validationErrors: run(this.state, fieldValidations)}); 
  }

  componentWillUnmount(){
    document.body.classList.remove('link-accout-page');
  }

  componentDidMount(){
    $.fn.getCursorPosition = function() {
    var el = $(this).get(0);
    var pos = 0;
    var posEnd = 0;
    if('selectionStart' in el) {
        pos = el.selectionStart;
        posEnd = el.selectionEnd;
    } else if('selection' in document) {
        el.focus();
        var Sel = document.selection.createRange();
        var SelLength = document.selection.createRange().text.length;
        Sel.moveStart('character', -el.value.length);
        pos = Sel.text.length - SelLength;
        posEnd = Sel.text.length;
    }
    // return both selection start and end;
    return [pos, posEnd];
  };


  $('#password_field').keydown(function (e) {
      //var pwd = $(this).attr('data-input');
      var pwd = $('#zpass').val();

      var position = $(this).getCursorPosition();
      var deleted = '';
      var val = $(this).val();
      if (e.which == 8) {
          if (position[0] == position[1]) {
              if (position[0] == 0){
                  deleted = '';
              }else{
                  deleted = val.substr(position[0] - 1, 1);
                  pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0] - 1, position[0]);
              }
          }
          else {
              deleted = val.substring(position[0], position[1]);
              pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0], position[1]);
          }
      }
      else if (e.which == 46) {
          var val = $(this).val();
          if (position[0] == position[1]) {
              if (position[0] === val.length) {
                  deleted = '';
              }else {
                  deleted = val.substr(position[0], 1);
                  pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0], position[0]+1);
              }
          }
          else {
              deleted = val.substring(position[0], position[1]);
              pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0], position[1]);
          }
      }
    // Now you can test the deleted character(s) here
    $('#zpass').val(pwd);


  });

  }
  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  handleFieldChanged(field) {
    return (e) => {
      // update() is provided by React Immutability Helpers
      // https://facebook.github.io/react/docs/update.html
      let newState = update(this.state, {
        [field]: {$set: e.target.value}
      });
      newState.validationErrors = run(newState, fieldValidations);
      this.setState(newState);
    };
  }

  login = () => {
    setTimeout(() => {
      if(!this.state.loginAttemptStarted) {
        return;
      }
      // After 40 seconds change values
      this.setState({showMoreMessageOnLogin: true});
    }, 40000)

    setTimeout(() => {
      if(!this.state.loginAttemptStarted) {
        return;
      }
      // After 80 seconds change values
      this.setState({showMoreMessageOnLogin: false});
      this.setState({showWaitLittleLonger: true});
    }, 80000)

    this.setState({showErrors: true});
    if($.isEmptyObject(this.state.validationErrors) === false) return null;

    this.setState({ loginAttemptStarted: true });
    this.setState({ loginAttemptFailed: false });

    var pwd = $('#zpass').val();
    RestClient.linkAccount(this.state.emailAddress.trim(), pwd.trim(), () => {

      //this is to do the another entrance in order to automatically select newly added account
      Entrance.silentEnter();
      //<-

      this.setState({ loginAttemptStarted: false });
      this.setState({ loginAttemptFailed: false });
      this.setState({ redirectToReferrer: true });
      this.setState({ showMoreMessageOnLogin: false});
      this.setState({showWaitLittleLonger: false});

      this.trigger('reloadSwitchAccountCombo');

    },
    (error) => {
      //console.log('authentication error');
      console.log(error);
      this.setState({ restError: error});
      this.setState({ loginAttemptStarted: false });
      this.setState({ loginAttemptFailed: true });
      this.setState({ showMoreMessageOnLogin: false});
      this.setState({showWaitLittleLonger: false});

      $('#zpass').val(null);
      var pwdField = document.getElementById("password_field");
      pwdField.value = null;
    })
  }

  countdownOfRedirectionToNewAccount(){
    var secondsLeft = (this.state.secondsLeftToNewAccountRedirection - 1);

    this.setState({secondsLeftToNewAccountRedirection:secondsLeft});

    if (secondsLeft === 0) {
      clearInterval(this.state.refreshIntervalId);

    }

  }

  copyPass() {
    var pwdField = document.getElementById("password_field");
    
    if (CommonHelper.isEmpty(pwdField)) {
      return;
    }

    if(this.state.showPassword) {
      pwdField.type = 'text';
    } else  {
      pwdField.type = 'password';
    }

    $('#zpass').val(pwdField.value);
  }

  changeType() {
    var pwdField = document.getElementById("password_field");

    if (CommonHelper.isEmpty(pwdField)) {
      return ;
    }
  }

  _handleChangeEvent(val) {
          return val;
        }

    handleReauthorizeClick () {
        window.open('https://staging.soundcloudhelper.com/login_redirect.php?user_id='+localStorage.IDUser, '_blank');
    };

  render() {
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) { //it is flag of success indeed
      return (
        <div className="login-page">
          <Container align="center">
            <Row>
              <p className='text-white'>The account was linked successfully!</p>
            </Row>
          </Container>
        </div>
      )
    }


    var authMessage0 = (Entrance.accountsMissingAtLastLogin())?
    'You can now authorize your 1st SoundCloud (SC) account.'
    :
    'Authorize at SoundCloud (SC) here in order to link that additional account.';



    var authMessage1 = (this.state.loginAttemptStarted)
        ? (<p class="text-red">For a better experiance stay on this page unit link is over.</p>):'';

    var authMessage2 = (this.state.loginAttemptFailed)
        ? (<p class="text-red">Login attempt failed: <i>{this.state.restError.message}</i> <br/> Try again, or contact customer support.</p>):'';

      //console.log(this.state.restError.title);
    var authMessage3 = (this.state.showMoreMessageOnLogin)
    ? (<p>The authorisation process is only required once, and will ensure safety and optimal <br/> functioning of SCHelper with your SoundCloud account.</p>):'';

    var authMessage4 = (this.state.showWaitLittleLonger)
    ? (<p class="mt-3">Please wait little longer. It will be done any second...</p>):'';

    return  (
      <div className="login-page">
        <Container align="center">
          <div className='login-page-shadow-box'>
            <p>{authMessage0}</p>
            {authMessage1}
            {authMessage2}
            {authMessage3}



              {((this.state.ver_mode === "v1")||(this.state.ver_mode === "V1")) ? (
                  <a href="#">
                      <img onClick={this.handleReauthorizeClick}
                           src="https://connect.soundcloud.com/2/btn-connect-sc-l.png"></img>
                  </a>
                      ) : (
                      <>
                          <TextView
                              id="sc_login_to_link"
                              placeholder="SC login"
                              disabled={this.state.loginAttemptStarted}
                              showError={this.state.showErrors}
                              type="email"
                              text={this.props.emailAddress}
                              onFieldChanged={this.handleFieldChanged("emailAddress")}
                              verticalWithError="true"
                              errorText={this.errorFor("emailAddress")}
                          />
                          <TextView
                              id="password_field"
                              placeholder="SC password"
                              showError={this.state.showErrors}
                              type="text"
                              disabled={this.state.loginAttemptStarted}
                              onFieldChanged={this.handleFieldChanged("password1")}
                              verticalWithError="true"
                              errorText={this.errorFor("password1")}
                              onFocus={this.changeType()}
                              onBlur={this.copyPass()}
                              dataInput=""
                          />
                          <Row>
                              <div class="show-hide-pass" onClick={(e) => {
                                  this.state.showPassword = !this.state.showPassword;
                                  this.copyPass();
                              }}>
                                  Show Password
                              </div>
                          </Row>
                          <button
                              disabled={this.state.loginAttemptStarted}
                              type="submit"
                              id="green"
                              className="sc-btn sc-btn-red sc-btn-big"
                              onClick={this.login}
                          >
                              <span>Link It!</span>
                          </button>
                      </>
                      )}

                      {this.state.loginAttemptStarted && <Countdown/>}

                      {authMessage4}

                      <input id="zpass" type="hidden" name="zpass" onChange={(e) => {
                      }}/>
                  </div>
                  </Container>

      </div>
     );
   }
 }
